module.exports = __webpack_public_path__ + "static/media/faceMask.6e6940dd.png";